import React, { useState } from "react";
import { Map as MapGoogle, Marker, Polyline } from 'google-maps-react';
import marker_icon_blue from "../../../assets/images/marker_icon_blue.png";

export const Map = ({ selectedRows, mapVisible, google, markers, showPolylines }) => {
    const [centerPoint, setCenterPoint] = useState({ lat: -15.7801, lng: -47.9292 });

    let selectedMarkers = markers.filter(m => {
        return selectedRows.includes(m.key)
    });

    const handleSetCenterPoint = (i) => {
        const arrayLastKey = selectedMarkers.lenght - 1;
        if(arrayLastKey === i){
            const m = selectedMarkers[arrayLastKey]; 
            setCenterPoint({ lat: m.latitude, lgn: m.longitude });
        }
    }

    const polylines = selectedMarkers.map((m, i) => {
        handleSetCenterPoint(i);

        return { lat: parseFloat(m.latitude), lng: parseFloat(m.longitude) }
    });

    var howShow;
    if (showPolylines) {
        howShow = <Polyline
            path={polylines}
            strokeColor="#0000FF"
            strokeOpacity={1.8}
            strokeWeight={2}
        />
    }
    else {
        howShow = selectedMarkers.map((place, i) => {
            handleSetCenterPoint(i);

            return <Marker
                key={`marker-${i + 1}`}
                label={{
                    text: place.plate,
                    fontFamily: "Arial",
                    fontSize: "14px",
                    color: "#8B0000",
                    backgroundColor: "green"
                }}
                title={place.plate}
                information={place}
                position={{ lat: place.latitude, lng: place.longitude }}
                icon={{
                    url: marker_icon_blue,
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(0, 35),
                    scaledSize: new window.google.maps.Size(35, 35),
                    labelOrigin: new window.google.maps.Point(60, 10),
                }}
            />
        });
    }

    return (
        <MapGoogle
            visible={mapVisible}
            google={google}
            zoom={4}
            zoomControl={true}
            zoomControlOptions={{
                style: window.google.maps.ZoomControlStyle.SMALL,
                position: window.google.maps.ControlPosition.RIGHT_BOTTOM
            }}
            scrollwheel={true}
            scaleControl={true}
            streetViewControl={true}
            streetViewControlOptions={{
                position: window.google.maps.ControlPosition.RIGHT_BOTTOM
            }}
            panControl={true}
            mapTypeControl={true}
            initialCenter={centerPoint}
            center={centerPoint}
        >
            {howShow}
        </MapGoogle>
    );
}
